import React from "react";
import Button from "../../atoms/Button/Button";
import Logo from "../../../static/logo.svg";
import SantaHat from "../../../static/santa-hat.svg";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import SearchField from "../../atoms/SearchField/SearchField";
import MenuIcon from "@mui/icons-material/Menu";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

interface SidebarTopProps {
  isTabletView: boolean;
  isSidebarFullScreen: boolean;
  onFullScreenOpen: () => void;
  onTabletOpen: () => void;
  onSearch: (searchValue?: string) => void;
}

const SidebarTop = (props: SidebarTopProps) => {
  const {
    isTabletView,
    isSidebarFullScreen,
    onSearch,
    onFullScreenOpen,
    onTabletOpen,
  } = props;

  const { t } = useTranslation();

  const isDecember = new Date().getMonth() === 11;

  const isCurrentlyInEditMode = useSelector(
    (state: any) => state.app.isInEditMode
  );
  return (
    <div className="dui-sidebar-top">
      {isCurrentlyInEditMode ? null : (
        <div className="dui-sidebar-expand">
          {isTabletView ? (
            <Button
              icon={<MenuIcon />}
              type="primary"
              onClick={() => {
                onTabletOpen();
              }}
            />
          ) : (
            <Button
              icon={isSidebarFullScreen ? <ChevronLeft /> : <ChevronRight />}
              type="primary"
              onClick={onFullScreenOpen}
            />
          )}
        </div>
      )}
      {isCurrentlyInEditMode && isTabletView ? (
        <div className="dui-sidebar-expand">
          <Button
            icon={<MenuIcon />}
            type="primary"
            onClick={() => {
              onTabletOpen();
            }}
          />
        </div>
      ) : null}

      <div className="dui-sidebar-logo">
        <img src={Logo} alt="Logo" />
        {isDecember && (
          <>
            <div className="dui-santa-hat">
              <img src={SantaHat} alt="Hat" />
            </div>
            <>
              {Array.from({ length: 70 }).map((_, i) => (
                <div
                  key={`s-${i}`}
                  className={`dui-snowflake dui-snowflake-${i + 1}`}
                >
                  ❄︎
                </div>
              ))}

              {Array.from({ length: 20 }).map((_, i) => (
                <div
                  key={`m-${i}`}
                  className={`dui-snowflake dui-snowflake-medium dui-snowflake-medium-${i + 1}`}
                >
                  ❄︎
                </div>
              ))}

              {Array.from({ length: 20 }).map((_, i) => (
                <div
                  key={`l-${i}`}
                  className={`dui-snowflake dui-snowflake-large dui-snowflake-large-${i + 1}`}
                >
                  ❄︎
                </div>
              ))}
            </>
          </>
        )}
      </div>
      {isSidebarFullScreen ? null : (
        <div className="dui-sidebar-search">
          <SearchField
            placeholder={`${t("searchDiagnosis")}...`}
            onSearch={onSearch}
            disabled={isCurrentlyInEditMode}
          />
        </div>
      )}
    </div>
  );
};

export default SidebarTop;
